import React, { FC, memo } from 'react'

import { focusIds } from '@/constants/focus'

import { ButtonElem, IconWrapper, Label } from './styles'
import { ButtonProps } from './types'

const ButtonRaw: FC<ButtonProps> = ({
  text,
  iconSrc,
  onClick,
  expand = false,
  smallButton = false,
  width,
  focusId,
  secondary,
  className,
  hideLabel,
  iconPositionEnd,
}) => {
  const buttonFocusId = focusId || `${focusIds.BUTTON}${text}`
  const withIcon = !!iconSrc
  return (
    <ButtonElem
      elementType="button"
      focusId={buttonFocusId}
      onSelected={onClick}
      className={className}
      $width={width}
      $expand={expand}
      $smallButton={smallButton}
      $secondary={secondary}
      $withIcon={withIcon}
      $iconPositionEnd={iconPositionEnd}
    >
      {withIcon && (
        <IconWrapper>
          <img src={iconSrc} alt="" />
        </IconWrapper>
      )}
      {!hideLabel && <Label>{text}</Label>}
    </ButtonElem>
  )
}

export const Button = memo(ButtonRaw)
